export function getVisibleBullets(slidesCount = 0, perView = 1, pages = false) {
	const bulletCount = Math.ceil(slidesCount / (pages ? perView : 1));
	const bullets = new Set();

	for (let i = 0; i < bulletCount; i++) {
		if (pages && (i * perView) + perView <= slidesCount) {
			bullets.add(i * perView);
		}
		else if (!pages && i + perView <= slidesCount) {
			bullets.add(i);
		}
		else {
			bullets.add(slidesCount - perView)
		}
	}

	return Array.from(bullets);
}

export function getActiveBullet(visibleBullets = [], activeSlide = 0) {
	return visibleBullets.reduce((active, bullet) => {
		return activeSlide >= bullet && bullet || active;
	}, 0);
}
